module.exports = __webpack_public_path__ + "img/unloading-img.1fdc8a8b.svg";